module.exports = __webpack_public_path__ + "static/media/icon-192x192.a2fa9d00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hinkley/icon-192x192.png
// module id = 715
// module chunks = 0